import { createAsyncThunk } from '@reduxjs/toolkit'
import ProfileReaction from './profile-reaction-model'
import {
  delete_profileReaction,
  load_profileReactions,
  store_profileReaction,
} from './profileReaction-service'

export const LoadProfileReactionsAsync = createAsyncThunk<any, any>(
  'composer/load/profileReaction',
  async (params: { uid: string }) => {
    return await load_profileReactions(params)
  },
)

export const CreateProfileReactionAsync = createAsyncThunk<any, any>(
  'composer/create/profileReaction',
  async (params: ProfileReaction) => {
    return await store_profileReaction(params)
  },
)

export const DeleteProfileReactionAsync = createAsyncThunk<any, any>(
  'composer/delete/profileReaction',
  async (params) => {
    return await delete_profileReaction(params)
  },
)
